<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">
 <vx-card title="Data">
   <h3>{{organizationModel.FullName}}</h3>
   <h3>In System from {{organizationModel.CreatedDate}}</h3>
   </vx-card>
   <!-- old Courses Request -->
     <vx-card :title="$t('CoursesRequest')" style="margin-top:20px">
    <vs-table ref="table" multiple v-model="selected" pagination :max-items="itemsPerPage" :data="customerCoursesRequests">

      <template slot="thead">
        <vs-th sort-key="Name">{{$t('Name')}}</vs-th>
         <vs-th sort-key="Name">{{$t('Date')}}</vs-th>
         <vs-th sort-key="Name">{{$t('Status')}}</vs-th>
      </template>

        <template slot-scope="{data}">
          <tbody>

            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
       <!-- mainData -->
              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.Course.Name }}</p>
              </vs-td>
               <vs-td>
                <p class="product-name font-medium truncate">{{ tr.RequestStartDate }}</p>
              </vs-td>
               <vs-td>
                <p class="product-name font-medium truncate">{{ tr.Status.Name }}</p>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
    </vs-table>
         </vx-card>
           <!-- old Invoices -->
     <vx-card title="Invoices " style="margin-top:20px">
       <div :data="invoice" :key="indextr" v-for="(invoice, indextr) in customerInvoices" > 
    <vs-table ref="table" multiple v-model="selected" pagination :max-items="itemsPerPage" :data="invoice.InvoiceDetails">

      <template slot="thead">
        <vs-th sort-key="Name">{{$t('Amount')}}</vs-th>
         <vs-th sort-key="Name">{{$t('Date')}}</vs-th>
         <vs-th sort-key="Name">{{$t('IsPayed')}}</vs-th>
      </template>

        <template slot-scope="{data}">
          <tbody>

            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
       <!-- mainData -->
              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.Amount }}</p>
              </vs-td>
               <vs-td>
                <p class="product-name font-medium truncate">{{ tr.Date }}</p>
              </vs-td>
               <vs-td>
                <p class="product-name font-medium truncate">{{ tr.IsPayed }}</p>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
    </vs-table>
    </div>
     </vx-card>
      <!-- old His Trainees -->
     <vx-card title="His Trainees " style="margin-top:20px">
       <!-- <div :data="tr" :key="indextr" v-for="(tr, indextr) in customerTrainees">  -->
        <!-- <h6>{{ tr.FullName }}   <router-link :to="{name:'TraineeHistory',params: { ID: tr.ID}}"  svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" ><feather-icon  icon="MapIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"  /></router-link>
              </h6>  -->
    <vs-table ref="table" multiple v-model="selected" pagination :max-items="itemsPerPage" :data="customerTrainees">

      <template slot="thead">
        <vs-th sort-key="Name">{{$t('FullName')}}</vs-th>
        
        <vs-th sort-key="Name">{{$t('JobTitle')}}</vs-th>
            <vs-th sort-key="Name">{{$t('IndustrySector')}}</vs-th>
      </template>

        <template slot-scope="{data}">
          <tbody>

            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
       <!-- mainData -->
              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.TraineeName }}</p>
              </vs-td>
               <vs-td>
                  <p class="product-name font-medium truncate">{{ tr.JobTitle }}</p>
                </vs-td>
                  <vs-td>
                  <p v-if="tr.IndustrySector" class="product-name font-medium truncate">{{ tr.IndustrySector.Name }}</p>
                </vs-td>
            </vs-tr>
          </tbody>
        </template>
    </vs-table>
    <!-- </div> -->
     </vx-card>
 <vs-button class="ml-4 mt-2" type="border"  color="danger" @click="cancle">{{$t('Cancel')}}</vs-button>
  </div>
</template>

<script>

import moduleCustomer from "@/store/user/customer/moduleCustomer.js";

export default {
  components: {
     
  },
  data() {
    return {
      selected: [],
     organizationModel:{},
     customerCoursesRequests:[],
     customerInvoices:[],
     customerTrainees:[],
      itemsPerPage: 3,
      isMounted: false,

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      rowDataForDelete: {},
      activeConfirm: false
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
  },

  methods: {
     cancle(){
      this.$router.push('/User/Organization'); 
    },
  },

  created() {
    debugger;
    if (!moduleCustomer.isRegistered) {
      this.$store.registerModule("customerList", moduleCustomer);
      moduleCustomer.isRegistered = true;
    }
      const ID = this.$route.params.ID
     if(ID!=undefined)
     {

      this.$store.dispatch("customerList/GetItemByID", ID)
      .then(res => {
         this.organizationModel = res.data
      debugger;
       })
      .catch(err => {
         debugger;
        if(err.response.status === 404) {
          this.user_not_found = true
          return
        }
        console.error(err) })

         this.$store.dispatch("customerList/GetAllCustomerCourseRequest", ID).then(res => {
         this.customerCoursesRequests = res.data
      debugger;
       })
  this.$store.dispatch("customerList/GetAllCustomerInvoices", ID).then(res => {
         this.customerInvoices = res.data
      debugger;
       })
         this.$store.dispatch("customerList/GetAllTraineeByCustomer", ID).then(res => {
         this.customerTrainees = res.data
      debugger;
       })

     }
  },
  mounted() {
    this.isMounted = true;
  }
};
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
